import Table from "../../../../components/Table";

function EmployeesTable({
  objects,
  onSort,
  schema,
  selected,
  onCollapse,
  ...props
}) {
  return (
    <>
      <div className="d-flex flex-column">
        <Table
          fields={schema.fields}
          onCollapse={onCollapse}
          collapsable
          objects={objects}
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false || options._read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["acl", "id", "created", "updated", "creator", "editor"],
          )}
          selected={selected}
          //   onSelectAll={this.onSelectAll.bind(this)}
          //   progress={progress}
          //   onClickItem={this.onClickItem.bind(this)}
          onSort={onSort}
          className="mt-1"
          {...props}
        />
      </div>
    </>
  );
}

export default EmployeesTable;
